<script>
  export let by_doing;
</script>

<p>
  By {by_doing} you agree with our <a href="/terms">Terms of Conditions</a> and <a
    href="/privacy"
  >Privacy Policy</a> .
</p>
